// extracted by mini-css-extract-plugin
export default {"avatar":"style-module--avatar--5YhYL","img":"style-module--img--TjxtR"};